export const getAxisDomain = (data: any[] | undefined, key: string, overhead = 1.05) =>
  data
    ? [0, Math.round(Math.max(...data.map(({ [key]: value }) => Number(value))) * overhead)]
    : undefined
